import { startGame } from './game.js';
import { registerServiceWorker } from './pwa/sw-register.js';
import './ui/styles.css';

const root = document.getElementById('app');
if (!root) throw new Error('cblix2: #app root missing');

startGame(root);
registerServiceWorker();
